import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import Button from "src/components/button/Button";
import Show from "src/components/film/program/Show";
import FilmwebLink from "src/components/filmweblink/FilmwebLink";
import Kinoklubb from "src/components/kinoklubb/Kinoklubb";
import MoviePosterImage from "src/components/program/MoviePosterImage";
import classNames from 'classnames';
import type { ProgramMovie } from "src/lib/types/filminfo/ProgramMovie";
import type { ProgramShow } from "src/lib/types/filminfo/ProgramShow";
import styles from './ProgrammedMovie.module.css';
import ExpandArrowSvg from "src/components/svg/ExpandArrowSvg";
import { useLocationContext, useProgramDatesContext, useSelectedCinemaContext } from "src/lib/contexts/ContextTypes";
import { buildProgramHash } from "src/lib/programHash";
import { slugifyTitle } from "src/lib/slug";
import { locale } from "@locale";
import getThemeStyles from "src/lib/styling/getThemeStyles";
import transformAgeRatings from "src/lib/locale/transformAgeRatings";

//#region [Props]
type ProgrammedMovieProps = {
  movie: ProgramMovie;
  hideTheatreName?: boolean;
  applyTheatreFilter?: boolean; // film links should pass on a theatre filter
};
//#endregion

//#region [Component]
export default function ProgrammedMovie(t0) {
  const $ = _c(79);
  const {
    movie,
    hideTheatreName: t1,
    applyTheatreFilter: t2
  } = t0;
  const hideTheatreName = t1 === undefined ? false : t1;
  const applyTheatreFilter = t2 === undefined ? false : t2;
  const selectedDateContext = useProgramDatesContext();
  const cinemaContext = useSelectedCinemaContext();
  const locationContext = useLocationContext();
  const [isExpanded, setIsExpanded] = useState(false);
  let genres = movie.genres;
  if (genres?.includes("Barnefilm") && genres?.includes("Familiefilm")) {
    let t3;
    if ($[0] !== genres) {
      t3 = genres.filter(_temp);
      $[0] = genres;
      $[1] = t3;
    } else {
      t3 = $[1];
    }
    genres = t3;
  }
  let isKinoklubb;
  let linkUrl;
  let t3;
  if ($[2] !== applyTheatreFilter || $[3] !== cinemaContext.selectedCinemas || $[4] !== locationContext?.firmId || $[5] !== movie.isKinoklubb || $[6] !== movie.mainVersionId || $[7] !== movie.shows?.[0]?.theaterName || $[8] !== movie.title || $[9] !== selectedDateContext.selectedDate || $[10] !== selectedDateContext.showingAllDates) {
    const themeStyles = getThemeStyles(styles);
    isKinoklubb = process.env.NEXT_PUBLIC_KINOKLUBB_ENABLED === "true" && movie.isKinoklubb;
    const theatreName = movie?.shows?.[0]?.theaterName;
    const theatreFilter = applyTheatreFilter && theatreName ? `?firm=${locationContext?.firmId}&theatre=${theatreName}` : "";
    const t4 = selectedDateContext.showingAllDates ? "all" : selectedDateContext?.selectedDate ?? null;
    let t5;
    if ($[14] !== cinemaContext.selectedCinemas || $[15] !== t4) {
      t5 = buildProgramHash({
        date: t4,
        cinemas: cinemaContext.selectedCinemas,
        genres: null
      });
      $[14] = cinemaContext.selectedCinemas;
      $[15] = t4;
      $[16] = t5;
    } else {
      t5 = $[16];
    }
    const selDate = t5;
    let t6;
    if ($[17] !== movie.mainVersionId || $[18] !== movie.title || $[19] !== selDate || $[20] !== theatreFilter) {
      t6 = movie.mainVersionId ? `/film/${movie.mainVersionId}${theatreFilter}${selDate}` : movie.title ? `/program/film/${encodeURIComponent(slugifyTitle(movie.title))}${theatreFilter}${selDate}` : undefined;
      $[17] = movie.mainVersionId;
      $[18] = movie.title;
      $[19] = selDate;
      $[20] = theatreFilter;
      $[21] = t6;
    } else {
      t6 = $[21];
    }
    linkUrl = t6;
    themeStyles[styles.SNoLink] = !linkUrl;
    t3 = classNames(styles.SMovieContainer, themeStyles);
    $[2] = applyTheatreFilter;
    $[3] = cinemaContext.selectedCinemas;
    $[4] = locationContext?.firmId;
    $[5] = movie.isKinoklubb;
    $[6] = movie.mainVersionId;
    $[7] = movie.shows?.[0]?.theaterName;
    $[8] = movie.title;
    $[9] = selectedDateContext.selectedDate;
    $[10] = selectedDateContext.showingAllDates;
    $[11] = isKinoklubb;
    $[12] = linkUrl;
    $[13] = t3;
  } else {
    isKinoklubb = $[11];
    linkUrl = $[12];
    t3 = $[13];
  }
  let t4;
  if ($[22] !== movie) {
    t4 = <MoviePosterImage className={styles.SPosterImage} movie={movie} />;
    $[22] = movie;
    $[23] = t4;
  } else {
    t4 = $[23];
  }
  let t5;
  if ($[24] !== linkUrl || $[25] !== t4) {
    t5 = <FilmwebLink prefetch={false} className={styles.SPosterContainerLink} to={linkUrl}>{t4}</FilmwebLink>;
    $[24] = linkUrl;
    $[25] = t4;
    $[26] = t5;
  } else {
    t5 = $[26];
  }
  let t6;
  if ($[27] !== movie.title) {
    t6 = <h2 className={styles.SMovieTitle}>{movie.title}</h2>;
    $[27] = movie.title;
    $[28] = t6;
  } else {
    t6 = $[28];
  }
  let t7;
  if ($[29] !== linkUrl || $[30] !== t6) {
    t7 = <FilmwebLink prefetch={false} className={styles.STitleLink} to={linkUrl}>{t6}</FilmwebLink>;
    $[29] = linkUrl;
    $[30] = t6;
    $[31] = t7;
  } else {
    t7 = $[31];
  }
  let t8;
  if ($[32] !== movie.rating) {
    t8 = transformAgeRatings(movie.rating);
    $[32] = movie.rating;
    $[33] = t8;
  } else {
    t8 = $[33];
  }
  let t9;
  if ($[34] !== t8) {
    t9 = <div className={styles.SNoWrap}>{t8}</div>;
    $[34] = t8;
    $[35] = t9;
  } else {
    t9 = $[35];
  }
  let t10;
  if ($[36] !== movie.lengthInMinutes) {
    t10 = !!movie.lengthInMinutes && <div className={styles.SNoWrap}>{Math.floor(movie.lengthInMinutes / 60) > 0 ? `${Math.floor(movie.lengthInMinutes / 60)}t ` : null}{`${movie.lengthInMinutes - 60 * Math.floor(movie.lengthInMinutes / 60)}m`}</div>;
    $[36] = movie.lengthInMinutes;
    $[37] = t10;
  } else {
    t10 = $[37];
  }
  let t11;
  if ($[38] !== genres) {
    t11 = (genres?.length ?? 0) > 0 && <div className={styles.SGenre}>{genres.join(" / ")}</div>;
    $[38] = genres;
    $[39] = t11;
  } else {
    t11 = $[39];
  }
  let t12;
  if ($[40] !== t10 || $[41] !== t11 || $[42] !== t9) {
    t12 = <div className={styles.SFacts}>{t9}{t10}{t11}</div>;
    $[40] = t10;
    $[41] = t11;
    $[42] = t9;
    $[43] = t12;
  } else {
    t12 = $[43];
  }
  let t13;
  if ($[44] !== isKinoklubb || $[45] !== movie.filteredShows) {
    t13 = isKinoklubb && areAnyShowsKinoklubb(movie.filteredShows) && <Kinoklubb className={styles.SKinoklubb} />;
    $[44] = isKinoklubb;
    $[45] = movie.filteredShows;
    $[46] = t13;
  } else {
    t13 = $[46];
  }
  let t14;
  if ($[47] !== hideTheatreName || $[48] !== isKinoklubb || $[49] !== movie.filteredShows) {
    t14 = movie.filteredShows?.slice(0, 3)?.map((show, index) => <Show key={show?.ticketSaleUrl ?? index} show={show} isKinoklubbMovie={isKinoklubb} hideTheatreName={hideTheatreName} />);
    $[47] = hideTheatreName;
    $[48] = isKinoklubb;
    $[49] = movie.filteredShows;
    $[50] = t14;
  } else {
    t14 = $[50];
  }
  let t15;
  if ($[51] !== hideTheatreName || $[52] !== isExpanded || $[53] !== isKinoklubb || $[54] !== movie.filteredShows) {
    t15 = (movie.filteredShows?.length ?? 0) > 3 && <div className={classNames(styles.SExpander, {
      [styles.expanded]: isExpanded
    })}>{movie.filteredShows?.slice(3)?.map((show_0, index_0) => <Show key={show_0?.ticketSaleUrl ?? index_0} show={show_0} isKinoklubbMovie={isKinoklubb} hideTheatreName={hideTheatreName} />)}</div>;
    $[51] = hideTheatreName;
    $[52] = isExpanded;
    $[53] = isKinoklubb;
    $[54] = movie.filteredShows;
    $[55] = t15;
  } else {
    t15 = $[55];
  }
  let t16;
  if ($[56] !== t14 || $[57] !== t15) {
    t16 = <div className={styles.SProgram}>{t14}{t15}</div>;
    $[56] = t14;
    $[57] = t15;
    $[58] = t16;
  } else {
    t16 = $[58];
  }
  let t17;
  if ($[59] !== linkUrl) {
    t17 = linkUrl && <FilmwebLink className={styles.SReadMoreLink} to={linkUrl}>{locale.program.movie.readMore}</FilmwebLink>;
    $[59] = linkUrl;
    $[60] = t17;
  } else {
    t17 = $[60];
  }
  let t18;
  if ($[61] !== isExpanded || $[62] !== movie.filteredShows?.length) {
    t18 = (movie.filteredShows?.length ?? 0) > 3 && <Button className={styles.ExpanderButton} text={isExpanded ? locale.program.movie.showLess : locale.program.movie.showMore} onClick={() => setIsExpanded(!isExpanded)} iconLocation="back" icon={<ExpandArrowSvg className={classNames(styles.ExpanderIcon, {
      [styles.isExpanded]: isExpanded
    })} />} />;
    $[61] = isExpanded;
    $[62] = movie.filteredShows?.length;
    $[63] = t18;
  } else {
    t18 = $[63];
  }
  let t19;
  if ($[64] !== t17 || $[65] !== t18) {
    t19 = <div className={styles.SLinks}>{t17}{t18}</div>;
    $[64] = t17;
    $[65] = t18;
    $[66] = t19;
  } else {
    t19 = $[66];
  }
  let t20;
  if ($[67] !== t12 || $[68] !== t13 || $[69] !== t16 || $[70] !== t19 || $[71] !== t7) {
    t20 = <div className={styles.SInfo}>{t7}{t12}{t13}{t16}{t19}</div>;
    $[67] = t12;
    $[68] = t13;
    $[69] = t16;
    $[70] = t19;
    $[71] = t7;
    $[72] = t20;
  } else {
    t20 = $[72];
  }
  let t21;
  if ($[73] !== t20 || $[74] !== t5) {
    t21 = <div className={styles.SMovie}>{t5}{t20}</div>;
    $[73] = t20;
    $[74] = t5;
    $[75] = t21;
  } else {
    t21 = $[75];
  }
  let t22;
  if ($[76] !== t21 || $[77] !== t3) {
    t22 = <article className={t3}>{t21}</article>;
    $[76] = t21;
    $[77] = t3;
    $[78] = t22;
  } else {
    t22 = $[78];
  }
  return t22;
}
//#endregion

//#region [Other] Helpers
function _temp(g) {
  return g !== "Barnefilm";
}
function areAnyShowsKinoklubb(shows: ProgramShow[] | undefined | null) {
  return shows?.some(show => show.isKinoklubb) ?? false;
}
//#endregion